import { getTimeDifference, momentInZone } from 'util/dateTime';
import { toI18n } from 'util/i18n';
import { isValidEmail, isValidPhone } from 'util/validators';

const emailIsInvalid = isValidEmail();
const phoneIsInvalid = isValidPhone();
const anyEmergencyContactFields = values =>
  values.emergency_contact_id ||
  values.emergency_contact_name ||
  values.emergency_contact_relationship ||
  values.emergency_contact_phone_number;

// Exports
export const handleValidate = values => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = toI18n(
      'team.employee_profile.employee_information.validations.first_name'
    );
  }

  if (values.email && emailIsInvalid(values.email)) {
    errors.email = toI18n(
      'team.employee_profile.employee_information.validations.email.format'
    );
  }

  if (values.phone_number && phoneIsInvalid(values.phone_number)) {
    errors.phone_number = toI18n(
      'team.employee_profile.employee_information.validations.phone'
    );
  }

  return errors;
};

export const getPayload = (currentCompany, values) => ({
  first_name: values.first_name,
  last_name: values.last_name,
  phone: values.phone_number,
  email: values.email,
  emergency_contact_attributes: anyEmergencyContactFields(values)
    ? {
        id: values.emergency_contact_id,
        full_name: values.emergency_contact_name,
        relationship: values.emergency_contact_relationship,
        phone: values.emergency_contact_phone_number,
      }
    : undefined,
});

export const renderComma = field => (!!field ? ',' : '');

export const getDisabledEditButtonOptions = (user, currentlyLoggedInUserId) => {
  const disableForMfa =
    user.get('mfa_enabled') && currentlyLoggedInUserId !== user.get('id');

  const disableForMoreJobs =
    user.get('has_jobs_at_more_than_one_company') &&
    user.get('id') !== currentlyLoggedInUserId;

  return disableForMoreJobs || disableForMfa
    ? toI18n(
        disableForMoreJobs
          ? 'product_usage.hover_text.edit_button_disabled_text'
          : `team.employee_profile.contact_information.info`,
        {
          props: {
            employee_name: user.get('first_name'),
          },
        }
      )
    : undefined;
};

const CONFIRMATION_TIME_LIMIT = 5;

export const handleShowAlert = ({
  date,
  setAlert,
  removeLocalStorageData,
  isUnverified,
}) => {
  if (!date) return;

  const differenceInMinutes = getTimeDifference(
    date,
    momentInZone(Date.now()),
    'minutes'
  );

  if (differenceInMinutes < CONFIRMATION_TIME_LIMIT && isUnverified)
    setAlert(true);
  else removeLocalStorageData();
};
